import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const TwoDotSixteenDotOne = () => {
  return (
    <ChangelogInstance version="2.16.1" date="2023-04-27">
      <li>
        Fixed broken float fetching.
      </li>
    </ChangelogInstance>
  );
}

export default TwoDotSixteenDotOne;